export default {
  aboutTag: "About Us",
  title1: "The Story Behind",
  title2: "My Food Truck Agency",
  subtitle:
    "Learn how we got started and why we're passionate about helping food entrepreneurs thrive in our community",
  ourStoryTag: "Our Story",
  storyTitle1: "Born from Frustration.",
  storyTitle2: "Built for Operators.",
  paragraph1:
    "We started My Food Truck Agency because we saw too many talented food entrepreneurs give up — not because their food wasn't good enough, but because California's permit process was just too overwhelming to figure out alone.",
  paragraph2:
    "The founder spent months helping a friend navigate Orange County health codes, commissary requirements, and city-by-city regulations. What should have taken weeks dragged on for months — and that friend almost quit.",
  paragraph3:
    "That experience made it clear: there needed to be a dedicated agency for OC food truck operators. Someone in their corner who already knew every form, every fee, and every inspector. That's exactly what we built.",
  founderName: "The OCFTA Team",
  founderRole: "Orange County Food Truck Specialists",
  founderYears: "1 year serving OC operators",
  milestonesTitle: "Our First Year — Milestone by Milestone",
  today: "Today",
  milestones: [
    {
      month: "Month 1",
      title: "We Opened Our Doors",
      description:
        "My Food Truck Agency was founded in Orange County with one mission: make it dead simple for food entrepreneurs to navigate California's complex permit landscape.",
    },
    {
      month: "Month 3",
      title: "First 10 Clients Permitted",
      description:
        "Within our first quarter we helped 10 food truck operators successfully obtain their Mobile Food Facility permits across OC cities including Anaheim, Santa Ana, and Irvine.",
    },
    {
      month: "Month 6",
      title: "Expanded to All 34 OC Cities",
      description:
        "We built relationships with health departments, commissaries, and city offices across all 34 cities in Orange County — giving clients a true one-stop shop for every jurisdiction.",
    },
    {
      month: "Month 9",
      title: "Launched Truck Build Program",
      description:
        "We partnered with certified food truck builders to offer end-to-end build consultations — connecting clients with vetted builders who already understand OC health code requirements.",
    },
    {
      month: "Year 1",
      title: "Still Here. Still Growing.",
      description:
        "One year in, we're proud of every operator we've helped get off the ground. We're expanding our services and doubling down on making OC the best place to run a food truck.",
    },
  ],
  ctaText: "Be part of the next chapter.",
  bookSession: "Book a Session",
};